import React from "react";
import { Route, Routes } from "react-router-dom";
import UserFlashSwiper from "./components/UserFlashSwiper";
import Main from "./Main";
import Home from "./views/Home";
import Polls from "./views/Polls";
import PrivacyPolicy from "./views/PrivacyPolicy";
import TermsOfService from "./views/TermsOfService";

const RouteHandler = () => {
    return (
        <>
            <Main />
            <Routes>
                <Route path="/" element={<Home />}>
                    <Route index element={<Polls />} />
                    <Route path="create-flash" element={<UserFlashSwiper />} />
                    {/* <Route path="activity" element={<Home />} /> */}
                </Route>
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
            </Routes>
        </>
    );
};

export default RouteHandler;
